import React, { useEffect, useState } from "react"
import PerfectScrollbar from "react-perfect-scrollbar"
import "react-perfect-scrollbar/dist/css/styles.css"
import { Box, Button, Checkbox, TableCell, TableRow } from "@material-ui/core"
import {
  ConfirmDialog,
  EnhancedTable,
  IconButton,
  PageSection
} from "src/components"
import PropTypes from "prop-types"
import moment from "moment/moment"
import { ProtectedElement } from "src/components/auth"
import { DeleteForeverTwoTone } from "@material-ui/icons"

const FuelDataTable = ({ data, onDeleteFuel, onImportFuelToExpense }) => {
  const [sortedData, setSortedData] = useState(null)

  useEffect(() => {
    if (data) {
      setSortedData(data)
    }
  }, [data])

  const handleOnSort = inData => {
    setSortedData(inData)
  }

  const totalFuel = () => {
    let output = 0
    if (sortedData) {
      sortedData.map(x => {
        output += x.amount
        return output
      })
    }
    return output
  }

  const headers = [
    {
      id: "fuelDate",
      numeric: false,
      disablePadding: false,
      label: "Date"
    },
    {
      id: "unitNumber",
      numeric: false,
      disablePadding: false,
      label: "Unit Number"
    },
    {
      id: "driverName",
      numeric: false,
      disablePadding: false,
      label: "Driver Name"
    },
    {
      id: "quantity",
      numeric: false,
      disablePadding: false,
      label: "QTY"
    },
    {
      id: "amount",
      numeric: false,
      disablePadding: false,
      label: "Amount"
    },
    {
      id: "fuelStateName",
      numeric: false,
      disablePadding: false,
      label: "State"
    },
    {
      id: "action",
      numeric: false,
      disablePadding: false,
      label: ""
    }
  ]

  const [confirmDialog, setConfirmDialog] = useState(null)
  const [selected, setSelected] = React.useState([])

  const handleOnCloseDialog = () => {
    setConfirmDialog(null)
  }

  const handleOnConfirmDelete = async item => {
    await onDeleteFuel(item)
    handleOnCloseDialog()
  }

  const handleDeleteItem = item => {
    const dialog = {
      text: `Are you sure you want to delete fuel in an amount of ${item.amount}`,
      onConfirm: () => handleOnConfirmDelete(item.fuelId),
      onCancel: () => handleOnCloseDialog(),
      isDialogOpen: true
    }
    setConfirmDialog(dialog)
  }

  const isSelected = name => selected.indexOf(name) !== -1

  const handleSelectAllClick = event => {
    if (event.target.checked) {
      const newSelecteds = sortedData.map(n => n.fuelId)
      setSelected(newSelecteds)
      return
    }
    setSelected([])
  }

  const handleCheckClick = (event, name) => {
    const selectedIndex = selected.indexOf(name)
    let newSelected = []

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name)
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1))
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1))
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      )
    }

    setSelected(newSelected)
  }

  return (
    <>
      <PageSection>
        <Box
          display="flex"
          justifyContent="flex-end"
          sx={{ typography: "subtitle2" }}
        >
          Total: ${totalFuel().toFixed(2)}
        </Box>
      </PageSection>
      <PerfectScrollbar>
        <Box sx={{ minWidth: 1050 }}>
          {sortedData && (
            <EnhancedTable
              data={sortedData}
              headers={headers}
              sortBy="fuelDate"
              sortOrder="asc"
              onSort={handleOnSort}
              onSelectAll={handleSelectAllClick}
              dense
            >
              {sortedData.map((item, index) => {
                const isItemSelected = isSelected(item.fuelId)
                const labelId = `enhanced-table-checkbox-${index}`
                return (
                  <TableRow
                    hover
                    key={item.fuelId}
                    selected={isItemSelected}
                    onClick={event => handleCheckClick(event, item.fuelId)}
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={isItemSelected}
                        inputProps={{ "aria-labelledby": labelId }}
                      />
                    </TableCell>
                    <TableCell>
                      {moment(item.fuelDate).format("MM/DD/YYYY")}
                    </TableCell>
                    <TableCell>{item.unitNumber}</TableCell>
                    <TableCell>{item.driverName}</TableCell>
                    <TableCell>{item.quantity}</TableCell>
                    <TableCell>${item.amount}</TableCell>
                    <TableCell>{item.fuelStateName}</TableCell>
                    <TableCell align="center">
                      <ProtectedElement
                        name="LoadBoardPage"
                        accessLevel="Write"
                      >
                        <IconButton
                          aria-label="Edit"
                          onClick={() => handleDeleteItem(item)}
                        >
                          <DeleteForeverTwoTone />
                        </IconButton>
                      </ProtectedElement>
                    </TableCell>
                  </TableRow>
                )
              })}
            </EnhancedTable>
          )}
        </Box>
      </PerfectScrollbar>
      <ConfirmDialog props={confirmDialog} />
      <Box justifyContent="space-between">
        <Box justifyContent="flex-start">
          <Button
            color="primary"
            variant="contained"
            onClick={() => onImportFuelToExpense(selected)}
          >
            Import Loads
          </Button>
        </Box>
      </Box>
    </>
  )
}

FuelDataTable.propTypes = {
  data: PropTypes.array,
  onDeleteFuel: PropTypes.func,
  onImportFuelToExpense: PropTypes.func
}

export default FuelDataTable
